import { IState, DefaultState } from "./state";
import { Types, Keys } from "./action/types";
import { room } from "../../../model/room";

export const reducer = (
  state: IState = DefaultState(),
  action: Types
): IState => {
  switch (action.type) {
    case Keys.LOADROOMS_FULFILLED: {
      let q: Array<room> = action.payload;
      return {
        ...state,
        rooms: q,
      };
    }
    case Keys.LOADROOMS_REJECTED: {
      return {
        ...state,
        rooms: [],
      };
    }
    case Keys.SELECTROOM: {
      var found = state.rooms.find((item) => {
        return item._id === action.payload;
      });
      return {
        ...state,
        room: found,
      };
    }
    case Keys.CHANGEROOMDESCRIPTION: {
      var found2 = state.rooms.find((item) => {
        return item._id === action.payload.id;
      });
      found2.description = action.payload.text;
      return {
        ...state,
        rooms: [...state.rooms],
      };
    }
    case Keys.CHANGEROOMACCESSRULE: {
      const { accessrule } = action.payload;
      return {
        ...state,
        room: { ...state.room, accessRule: { ...accessrule } },
      };
    }
    case Keys.CHANGEROOMINEDIT: {
      const room = action.payload;
      return {
        ...state,
        room: { ...room },
      };
    }
    case Keys.LOADROOMDETAIL_FULFILLED: {
      let q: room = action.payload;
      return {
        ...state,
        room: q,
      };
    }
    case Keys.LOADROOMDETAIL_REJECTED: {
      return {
        ...state,
        room: undefined,
      };
    }
    case Keys.CREATEROOM_REJECTED: {
      return {
        ...state
      };
    }
    case Keys.CREATEROOM_FULFILLED: {
      let rooms = state.rooms;
      rooms.push(action.payload)
      return {
        ...state,
        rooms: [ ...rooms ],
      };
    }
    case Keys.SAVEROOM_FULFILLED: {
      // let room: boo = action.payload;
      // let tags: Array<tag> = [...state.tags];
      // var curr = tags.findIndex((t) => t._id == tag._id);
      // if (curr > -1) tags.splice(curr, 1, tag);
      // else tags.push(tag);
      return {
        ...state,
      };
    }
    case Keys.SAVEROOM_REJECTED: {
      return {
        ...state,
      };
    }
    default:
      return state;
  }
};
